@if (level()) {
  <span
    class="text-sm font-semibold"
    [ngClass]="textClass()"
    [pTooltip]="tooltipKey() | transloco"
    tooltipPosition="top"
    [attr.data-testid]="testId()"
    >{{ labelKey() | transloco }}</span
  >
} @else {
  <span class="text-secondary text-sm italic" [attr.data-testid]="testId()">{{
    'hrTool.aiProfile.notDeclared' | transloco
  }}</span>
}
